import styled, { css } from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'

interface ITooltipProps {
    isLarge?: boolean
    offsetSizes?: number
    isChoosenIcon?: boolean
}

export const Tooltip = styled.span<ITooltipProps>`
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    overflow: auto;
    padding: 16px 24px;
    background-color: ${({ theme }) => theme.colors.grayscale_900};
    width: ${({ isLarge, offsetSizes }) => {
        if (isLarge) {
            return '370px'
        } else if (offsetSizes) {
            return `calc(100vw - 34px - ${offsetSizes}px)`
        } else {
            return 'calc(100vw - 34px)'
        }
    }};

    @media ${respondAbove.md} {
        width: ${({ isLarge }) => (isLarge ? '100vw' : 'max-content')};
        max-width: ${({ isLarge }) => (isLarge ? '370px' : '336px')};
    }

    @media ${respondAbove.xl} {
        border-radius: 7px;
    }
`

export const TippyWrapper = styled.div<ITooltipProps>`
    position: relative;
    width: ${({ isLarge }) => (isLarge ? '22px' : '24px')};
    height: ${({ isLarge }) => (isLarge ? '22px' : '24px')};

    ${({ isChoosenIcon }) =>
        isChoosenIcon &&
        css`
            display: flex;
            align-items: center;
        `}

    .tippy-box {
        @media ${respondAbove.xl} {
            max-width: ${({ isLarge }) =>
                isLarge ? '370px' : '336px'} !important;
            width: max-content;
        }
    }
`
